module.exports = __webpack_public_path__ + "img/t2-i2.ea76d918.svg";